define('core/utils/models',[
    'underscore',
], function (
    _
) {
    'use strict';

    /**
     * A Utility file for model functionality shared between backbone models and
     * react representations of those models.
     */

    var channelUtils = {
        /**
         * Adds some commonly expected additional fields to the json of a channel.
         *
         * @param  {Object} json - A json representation of a channel (either the
         *                         channel details from the api or the result of
         *                         calling toJSON on a backbone channel model)
         *
         * @returns {Object} - The given json with some additional common fields
         */
        extendJSON: function (json) {
            var name = json.name || '';

            return _.defaults({
                // TODO: should name this just avatar. Can get rid of withChannelAvatar
                // and access those values from channel's json. At that time, rename
                // channelAvatar to avatar.
                // https://trello.com/c/NgiflpfS/121-remove-withchannelavatar-mixin
                channelAvatar: json.avatar || json.options.favicon,
                bannerColorClass: json.bannerColor ? '-' + json.bannerColor : '',
                channelInitial: name.charAt(0),
            }, json);
        },
    };

    return {
        channel: channelUtils,
    };
});

